/**
 * Tags a link with the app-standard ?referrer= param, naming the page to return
 * to (the document page's root breadcrumb reads it).
 * @param {string} href The link.
 * @param {string} referrer The page to return to.
 * @return {string} The tagged link.
 */
export function withReferrer(href: string, referrer: string): string {
  return `${href}${href.includes('?') ? '&' : '?'}referrer=${referrer}`;
}
